/**
 * External website URLs for the marketing site
 * Marketing pages (landing, about, contact, privacy, terms) are hosted separately
 */

export const EXTERNAL_WEBSITE_BASE = 'https://examsprepwebsite-444f4522760d.herokuapp.com';

export const EXTERNAL_LINKS = {
  home: `${EXTERNAL_WEBSITE_BASE}/`,
  about: `${EXTERNAL_WEBSITE_BASE}/about`,
  contact: `${EXTERNAL_WEBSITE_BASE}/contact`,
  pricing: `${EXTERNAL_WEBSITE_BASE}/#pricing`,
  privacyPolicy: `${EXTERNAL_WEBSITE_BASE}/privacy_policy`,
  termsAndConditions: `${EXTERNAL_WEBSITE_BASE}/terms_and_conditions`,
  whatsappGroup: 'https://chat.whatsapp.com/EXAMSPREP_GROUP_INVITE_LINK',
  supportEmail: 'info@omegtric.com',
};

/**
 * Common props for external links (opens in new tab with security)
 */
export const EXTERNAL_LINK_PROPS = {
  target: '_blank',
  rel: 'noopener noreferrer',
};
